import { useContext } from 'react'
import { ContentOptionsContext } from './ContentOptionsProvider.tsx'

export const useContentOptionsContext = () => {
  return useContext(ContentOptionsContext)
}
